<div class="chart-container" #chartContainer>
    <ngx-charts-bar-horizontal-stacked
        [view]="[chartContainer.offsetWidth, chartContainer.offsetHeight]"
        [scheme]="colorScheme()"
        [results]="chartData()"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [showDataLabel]="showDataLabel"
        [showGridLines]="showGridLines"
        [barPadding]="barPadding" />
</div>
